import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import Progress from 'components/ui/progress';
import Skeleton from 'components/ui/skeleton';
import { PlanCheckoutModal } from 'components/portal/PlanCheckoutModal';
import { formatDayMonth } from 'lib/dateFormat';
import { usePortalSubscription } from 'modules/portal-plans/usePortalSubscription';

/** Settings → Subscription: the learner's plan, tests left this period, and renew or choose a plan. */
export default function Subscription() {
  const { t } = useTranslation();
  const { data: subscription, isLoading } = usePortalSubscription();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const active = Boolean(subscription && new Date(subscription.periodEnd).getTime() > Date.now());

  if (isLoading) return <Skeleton className="h-32 w-full max-w-xl rounded-lg" />;

  return (
    <section aria-labelledby="subscription-title" className="max-w-xl rounded-lg border border-border bg-card p-5 md:p-6">
      {checkoutOpen && <PlanCheckoutModal open onOpenChange={setCheckoutOpen} subscription={subscription} />}
      {active && subscription ? (
        <>
          <h2 id="subscription-title" className="text-[15px] font-semibold text-foreground">
            {t('portal_nav_plan_pill', { plan: subscription.planName })}
          </h2>
          {subscription.mockLimit > 0 && <Progress value={subscription.mocksRemaining} max={subscription.mockLimit} className="mt-4" />}
          <p className="mt-3 text-[13.5px] text-muted-foreground">
            <span className="font-semibold tabular-nums text-foreground">
              {subscription.mocksRemaining} / {subscription.mockLimit}
            </span>{' '}
            {t('portal_tests_plan_left')} ·{' '}
            {t('portal_tests_plan_until', {
              date: formatDayMonth(subscription.periodEnd),
            })}
          </p>
          <Button
            className="mt-5"
            size="sm"
            variant={subscription.isRenewalDue ? 'default' : 'outline'}
            onClick={() => setCheckoutOpen(true)}
          >
            {t('subscription.renew')}
          </Button>
        </>
      ) : (
        <>
          <h2 id="subscription-title" className="text-[15px] font-semibold text-foreground">
            {t('subscription.none_title')}
          </h2>
          <p className="mt-1.5 text-[13.5px] text-muted-foreground">{t('subscription.none_body')}</p>
          <Button className="mt-5" size="sm" onClick={() => setCheckoutOpen(true)}>
            {t('subscription.choose')}
          </Button>
        </>
      )}
    </section>
  );
}
